import { render, staticRenderFns } from "./ExpiringPoints.vue?vue&type=template&id=18f95a60&scoped=true&"
import script from "./ExpiringPoints.vue?vue&type=script&lang=js&"
export * from "./ExpiringPoints.vue?vue&type=script&lang=js&"
import style0 from "./ExpiringPoints.vue?vue&type=style&index=0&id=18f95a60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f95a60",
  null
  
)

export default component.exports